import React from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

const ContainerWithShadow: React.FC<React.HTMLProps<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div className={cn(styles.root, className)} {...props}>
      {children}
    </div>
  );
};

export default ContainerWithShadow;
